/* ==========================================================================
   EZRAH COUTURE — homepage transparent-header toggle
   Loaded only from sections/header.liquid, and only on the index template.
   The header floats transparent over the hero, then snaps to a solid
   --ezrah-bg surface (with a bottom hairline) once the page is scrolled
   ~80px. This layers ON TOP of Dawn's <sticky-header> custom element — it
   only toggles a class, it never touches scroll/reveal/hide behaviour.
   ========================================================================== */
(function () {
  'use strict';

  var wrapper = document.querySelector('[data-ezrah-transparent-header]');
  if (!wrapper) return;

  var THRESHOLD = 80;
  var solid = null;
  var ticking = false;
  // Mobile (<=989px): the transparent state is disabled outright, so the
  // header always renders solid — matches this header's own existing
  // mobile/desktop split (max-width: 989px / min-width: 990px).
  var MOBILE_QUERY = window.matchMedia('(max-width: 989px)');

  function setSolid(next) {
    if (next === solid) return;
    solid = next;
    wrapper.classList.toggle('ezrah-header--solid', solid);
    wrapper.classList.toggle('ezrah-header--transparent', !solid);
  }

  function measure() {
    if (MOBILE_QUERY.matches) {
      setSolid(true);
      ticking = false;
      return;
    }
    setSolid((window.pageYOffset || document.documentElement.scrollTop) > THRESHOLD);
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(measure);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  // Set the initial state (handles reload mid-page).
  measure();
})();
